import React, { Component } from "react";
import { getSongFromDB } from '../../services/IndexDB';
import { isChrome as chrome, isEdge as edge } from "react-device-detect";
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';
import $ from 'jquery';
import InstructorToolTip from "./InstructorToolTip";
import classnames from "classnames";

class PlaylistContent extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			playlistIndex: 0,
			playlistArray: [],
			currentSong: {},
			isPlayedSong: false,
			isOpenList: false,
			sep: '~@$',
			progressWidth: 0,
			currentSongSeconds: 0,
			isOpenVolume: false,
			songVolume: 20,
			isScreenShared: false,
			forceHidePlaylist: false,
			isLoadingSong: false,
			toolTipText: '',
			toolTipMsg: 0,
			isPlayingFm: false,
			volumeFM: 50
		}
		
		this.songInterval = null;
		this.getSongFromDB = getSongFromDB.bind(this);
		this.playerFunctions = window['playerFunctions'];
		window['showVolume'] = this.showVolume;
	}
 
	componentDidMount(){
		var sessionData = JSON.parse(localStorage.getItem('userData')).sessionData;
		
		if ( sessionData && sessionData.playlist && sessionData.playlist.length > 0 )
			{
				var playlistSongs = sessionData.playlist[0].songs;
				this.setState({playlistIndex: 0, playlistArray: playlistSongs, currentSong: playlistSongs[0]})
			}
			
		if ( localStorage.getItem('forceHidePlaylist') )
			{
				this.setState({ forceHidePlaylist: true});
			}
	}
	
	componentWillUnmount(){
	  clearInterval(this.songInterval);
	  this.songInterval = null;
	}
	
	openCloseList=()=>{
		var isOpenListVar = this.state.isOpenList;
		if ( isOpenListVar )
			{
				$('#playlist_content').removeClass('playListShow');
			}
		else 
			{	
				$('#playlist_content').addClass('playListShow');
			}
			
		isOpenListVar = !isOpenListVar;
		this.setState({isOpenList: isOpenListVar, isOpenVolume: false});
	}
	
	preventDef=(e)=>{
		e.preventDefault();
		e.stopPropagation();
	}
	
	playCurrentSong=()=>{
		var isNewSong = false;
		var mainthis = this;
		if ( mainthis.songInterval ) { clearInterval(mainthis.songInterval); mainthis.songInterval = null }
		
		mainthis.setState({isLoadingSong: true});
		
		var currentSongSecondsVar = this.state.currentSongSeconds;
		var currentSong = this.state.playlistArray[this.state.playlistIndex];
		var splitLength = currentSong.length.split(':');
		var fullSecondsLength = (parseInt(splitLength[0]) * 60) + parseInt(splitLength[1]);
	
		if ( currentSongSecondsVar == 0  )
			{
				if ( window['electron'] )
					{
						if ( currentSong.electronId )
							{
								window['mainLocalStream'].startAudioMixing({
									filePath: currentSong.fileName,
									playTime: 0
								}, function(error) {
									if (error) { console.log('err---', error); return; }
								});
							}
					}
				else
					{
						this.getSongFromDB(currentSong.fileName).then((res) =>{
							window['mainLocalStream'].startAudioMixing({
								filePath: res,
								playTime: 0
								}, function(error) {
									if (error) { console.log('err---', error); return; }
							});
						}).catch((err) => console.log("REJECTED", err)); 
					} 
					
				currentSongSecondsVar = 0;
			}
		else
			{
				window['mainLocalStream'].resumeAudioMixing();
			}
		
		window['mainLocalStream'].on("audioMixingPlayed", function() {
			if ( mainthis.songInterval ) { clearInterval(mainthis.songInterval); mainthis.songInterval = null }
			
			window['mainLocalStream'].adjustAudioMixingVolume(mainthis.state.songVolume);
			if ( window['electron'] ) { window['mainLocalStream'].adjustAudioMixingPublishVolume(mainthis.state.songVolume); }
			
			mainthis.setState({isPlayedSong: true, isLoadingSong: false});
			mainthis.songInterval = setInterval(function(){ 
				currentSongSecondsVar++;
				mainthis.setState({currentSongSeconds: currentSongSecondsVar})
				if ( currentSongSecondsVar == fullSecondsLength )
					{
						clearInterval(mainthis.songInterval);
						mainthis.songInterval = null;
						window['mainLocalStream'].stopAudioMixing();
						var currentIndex = mainthis.state.playlistIndex;
						currentIndex = currentIndex + 1;
						currentSongSecondsVar = 0;
						var playlistSongs = mainthis.state.playlistArray;
						if ( mainthis.state.playlistArray[currentIndex] )
							{
								mainthis.setState({
												progressWidth: 0, 
												playlistIndex: currentIndex, 
												currentSongSeconds: 0,
												currentSong: playlistSongs[currentIndex]
												}, () => {mainthis.playCurrentSong()});
							}
						else
							{
								mainthis.setState({
												playlistIndex: 0, 
												progressWidth: 0, 
												currentSongSeconds: 0, 
												currentSong: playlistSongs[0], 
												isPlayedSong: false
											});
							}
					}
				else
					{
						mainthis.calculateProgress(fullSecondsLength, currentSongSecondsVar);
					}
			}, 1000);
		});	
	}
	
	calculateProgress=(fullTime, currentTime)=>{
		var percent = (parseInt(currentTime) / parseInt(fullTime)) * 100;
		this.setState({progressWidth: percent});
	}
	
	pauseCurrentSong=()=>{
		window['mainLocalStream'].pauseAudioMixing();
		clearInterval(this.songInterval);
		this.songInterval = null;
		this.setState({isPlayedSong: false});
	}
	
	playFromPopup=(i)=>{
		var song = this.state.playlistArray[i];
		if ( window['mainLocalStream'] ) { window['mainLocalStream'].stopAudioMixing(); }
		if ( this.songInterval )
			{
				clearInterval(this.songInterval);
				this.songInterval = null;
			}
			
		this.setState({
				progressWidth: 0, 
				playlistIndex: i, 
				currentSongSeconds: 0,
				currentSong: song
		}, () => { this.playCurrentSong() });
	}
	
	playSongControl=(mod)=>{
		var currentIndex = this.state.playlistIndex;
		if ( mod == 'next' ) { currentIndex++; }
		else { currentIndex--; }
		
		if ( window['mainLocalStream'] ) { window['mainLocalStream'].stopAudioMixing(); }
		if ( this.songInterval )
			{
				clearInterval(this.songInterval);
				this.songInterval = null;
			}
			
		var song = this.state.playlistArray[currentIndex];
			
		this.setState({
				progressWidth: 0, 
				playlistIndex: currentIndex, 
				currentSongSeconds: 0,
				currentSong: song
		}, () => { this.playCurrentSong() });
	}
	
	openCloseVolume=()=>{
		var isOpenVolumeVar = this.state.isOpenVolume;
		if ( isOpenVolumeVar )
			{
				$('#playlist_content').removeClass('playListShow');
			}
		else 
			{	
				$('#playlist_content').addClass('playListShow');
			}			
		isOpenVolumeVar = !isOpenVolumeVar;
		this.setState({isOpenVolume: isOpenVolumeVar, isOpenList: false});
	}
	
	changeVolume=(e)=>{
		this.setState({songVolume: parseInt(e.target.value)});
	}
	
	reduceVolume=()=>{
		if ( this.state.isPlayedSong && window['mainLocalStream'] )
			{
				window['mainLocalStream'].adjustAudioMixingVolume(this.state.songVolume);
				if ( window['electron'] ) { window['mainLocalStream'].adjustAudioMixingPublishVolume(this.state.songVolume); }
			}
	}
	
	shareHideScreen=()=>{
		var mainthis = this;
		if ( mainthis.state.isScreenShared )
			{
				if ( window['electron'] )
					{
						if ( window['globalAgora'] )
							{
								window['globalAgora'].agora.enableLoopbackRecording(false);
								mainthis.setState({isScreenShared: false});
							}
					}
				else
					{
						if ( window['sharingScreen'] )
							{
								window['mainLocalStream'].replaceTrack(window['oldStreamTrack']);
								if ( typeof window['stopRecordAndStartNew'] == 'function' ) 
									{ 
										window['stopRecordAndStartNew']('restartlocal'); 
									}
									
								if ( window['acontx'] )
									{
										window['acontx'].suspend();
										window['acontx'] = null;
										
									}
								window['adestt'] = null; 	
								window['sharingScreen'].getTracks().forEach(track => track.stop());
							}
							
						mainthis.setState({isScreenShared: false});
					}
			}
		else
			{
				if ( window['electron'] )
					{
						if ( window['globalAgora'] )
							{
								console.log('START SHAREEEEEEEEEEEEEEEEE');
								window['globalAgora'].agora.enableLoopbackRecording(true);
								mainthis.setState({isScreenShared: true});
								window['globalAgora'].agora.adjustAudioMixingPublishVolume(100);
								mainthis.props.showMainErrorPop('Audio is now being captured from your speaker.');
							}
					}
				else
					{
						try 
						{
							navigator.mediaDevices.getDisplayMedia({video:true, audio: true}).then(function (screenMediaStream) {
								if ( screenMediaStream.getAudioTracks().length > 0 )
									{
										window['oldStreamTrack'] = window['mainLocalStream'].stream.getAudioTracks()[0].clone();
										
										window['acontx'] = new AudioContext();
										window['adestt'] = window['acontx'].createMediaStreamDestination();
										
										window['acontx'].createMediaStreamSource(new MediaStream([window['oldStreamTrack']])).connect(window['adestt']);
										window['acontx'].createMediaStreamSource(new MediaStream([screenMediaStream.getAudioTracks()[0]])).connect(window['adestt']);
										
										window['sharingScreen'] = screenMediaStream;
										window['mainLocalStream'].replaceTrack(window['adestt'].stream.getAudioTracks()[0]);
										if ( typeof window['stopRecordAndStartNew'] == 'function' ) { window['stopRecordAndStartNew']('restartlocal'); }
										
										window['manualSongChange'] = true;
										window['mainLocalStream'].stopAudioMixing();
										
										mainthis.props.showMainErrorPop('Audio is now being captured from your speaker.');
									}
								mainthis.setState({isScreenShared: true});	
							});
						} catch (e) { console.log('Unable to acquire screen capture: ' + e); }
					}
			}
	}
	
	showToolTip=(num, mod)=>{
		this.setState({
			toolTipText: mod,
			toolTipMsg: num,
		});
	}
	
	hideToolTip=()=>{
		this.setState({
			toolTipText: '',
			toolTipMsg: 0,
		});
	}
	
	hideToolInner=(e)=>{
		this.setState({
			toolTipText: '',
			toolTipMsg: 0,
		});
		e.preventDefault();
		e.stopPropagation();
	}
	
	showVolume=(mod)=>{
		this.setState({isPlayingFm: mod})
	}
	
	changeVolumeFm=(e)=>{
		this.setState({[e.target.id]: e.target.value});
		this.playerFunctions.changeVolume(e.target.value);
	}
	
	render() {
		return (
			<div className="playlist_footer" id="playlist_content">
				<div className={classnames("" + (this.state.playlistArray.length > 0 ? "holder_playlistMin" : "" ))}  >
				{ ( this.state.playlistArray.length > 0 && !this.state.forceHidePlaylist ) &&
					<div className="inline_playlist">
						<div className="song_animation_host"></div>
						<div className="song_info">
							<div className="songname">{this.state.currentSong.name}</div>
							<div className="songartist">{this.state.currentSong.artist}</div>
						</div>
						{ !this.state.isPlayedSong && !this.state.isLoadingSong &&
							<div className="play_icon_pl" id="playlist_play" onClick={this.playCurrentSong} onMouseOver={e=>{this.showToolTip(7, 'Play Song')}} onMouseLeave={this.hideToolTip} >
								{this.state.toolTipMsg == 7 &&	
									<InstructorToolTip
										state={this.state}
									></InstructorToolTip>
								}
							</div>
						}
						{ this.state.isPlayedSong && !this.state.isLoadingSong &&
							<div className="pause_icon_pl" onClick={this.pauseCurrentSong} onMouseOver={e=>{this.showToolTip(6, 'Pause Song')}} onMouseLeave={this.hideToolTip} >
								{this.state.toolTipMsg == 6 &&	
									<InstructorToolTip
										state={this.state}
									></InstructorToolTip>
								}
							</div>
						}
						{ this.state.isLoadingSong &&
							<div className="song_loading"></div>
						}
						<div className="progress_playlist">
							<div className="song_length" style={{width: this.state.progressWidth+'%'}}></div>
						</div>
						<div className={"control_playlist prevsong " + ( this.state.playlistIndex === 0  ? "opacity_control" : "" ) } onClick={ this.state.playlistIndex !== 0 ? () => this.playSongControl('prev') : undefined } onMouseOver={e=>{this.showToolTip(5, 'Previous Song')}} onMouseLeave={this.hideToolTip}>
							{this.state.toolTipMsg == 5 &&	
								<InstructorToolTip
									state={this.state}
								></InstructorToolTip>
							}
						</div>
						<div className={"control_playlist nextsong " + ( this.state.playlistIndex === (this.state.playlistArray.length-1)  ? "opacity_control" : "" ) } onClick={ this.state.playlistIndex !== (this.state.playlistArray.length-1) ? () => this.playSongControl('next') : undefined } onMouseOver={e=>{this.showToolTip(4, 'Next Song')}} onMouseLeave={this.hideToolTip}>
							{this.state.toolTipMsg == 4 &&	
								<InstructorToolTip
									state={this.state}
								></InstructorToolTip>
							}
						</div>
						<div className="control_playlist mutesong" onClick={this.openCloseVolume} onMouseOver={e=>{this.showToolTip(3, 'Change Volume')}} onMouseLeave={this.hideToolTip} >
							<div>
							{this.state.toolTipMsg == 3 &&	
								<InstructorToolTip
									state={this.state}
								></InstructorToolTip>
							}
							{ this.state.isOpenVolume &&
								<div className="range_container" onClick={this.preventDef} onMouseOver={e=>{this.hideToolInner(e)}}>
									<input type="range" className="range_playlist" value={this.state.songVolume} onChange={this.changeVolume} onMouseUp={this.reduceVolume} onTouchEnd={this.reduceVolume} />
								</div>
							}
							</div>
						</div>
						<div className="control_playlist listsong" onClick={this.openCloseList} onMouseOver={e=>{this.showToolTip(2, 'Playlist Songs')}} onMouseLeave={this.hideToolTip} >
							<div>
								{this.state.toolTipMsg == 2 &&	
									<InstructorToolTip
										state={this.state}
									></InstructorToolTip>
								}
							{ this.state.isOpenList &&
								<div className="list_content" onClick={this.preventDef} onMouseOver={e=>{this.hideToolInner(e)}} >
									<div className="list_title">Playlist</div>
									{ this.state.playlistArray.map((item, i) =>
										<div className="one_song_content" key={i}>
											<div className="song_name">{item.artist}</div>
											<div className="song_art">{item.name}</div>
											{ i !== this.state.playlistIndex &&
												<div className="playpop" onClick={() => this.playFromPopup(i)}></div>
											}
										</div>
									)}
								</div>
							}
							</div>
						</div>
						{ ( window['electron'] || chrome || edge ) &&
							<div className="control_playlist sharesong shareWithPlaylist" onClick={this.shareHideScreen} onMouseOver={e=>{this.showToolTip(1, 'Share Audio')}} onMouseLeave={this.hideToolTip}>
								{this.state.toolTipMsg == 1 &&	
									<InstructorToolTip
										state={this.state}
									></InstructorToolTip>
								}								
								{this.state.isScreenShared &&
									<div className="muted_audio stop_share">
									</div>
								}
							</div>
						}
					</div>
				}
				{ ( window['electron'] || chrome || edge ) && this.state.playlistArray.length == 0 &&
					<div className="control_playlist sharesong posRel" onClick={this.shareHideScreen} onMouseOver={e=>{this.showToolTip(1, 'Share Audio')}} onMouseLeave={this.hideToolTip}>
						{this.state.toolTipMsg == 1 &&	
							<InstructorToolTip
								state={this.state}
							></InstructorToolTip>
						} 
						{this.state.isScreenShared &&
							<div className="muted_audio stop_share">
							</div>
						}
					</div>
				}
				{ this.state.isPlayingFm &&
					<div className="feed_control_container host_feed_control">
						<div className="fm_controls">
							<input type="range" id="volumeFM" value={this.state.volumeFM} name="volume "min="0" max="100" onChange={this.changeVolumeFm} />
						</div>
					</div>
				}
				</div>
			</div>		
	)}
}

export default connect(
  null,
  { 
	showMainErrorPop
  }
)(PlaylistContent);